import { h, Component } from 'preact';

import { joinClasses } from 'utils/utils';
import { Howl } from 'howler';
import Store from 'store/store';

import s from 'components/bolt/sound/sound.sss';

export default class Sound extends Component {
	constructor(props) {
		super(props);
		this.volumeLevel = 0.5;

		this.loopingIntro = true;

		this.initialise = this.initialise.bind(this);
		this.startIntro = this.startIntro.bind(this);
		this.toggleMute = this.toggleMute.bind(this);
		this.reset = this.reset.bind(this);
		this.onPortalStart = this.onPortalStart.bind(this);
		this.onPortalEnded = this.onPortalEnded.bind(this);
		this.onScrollToContent = this.onScrollToContent.bind(this);
		this.onTransitionStarted = this.onTransitionStarted.bind(this);
		this.onSkipPortal = this.onSkipPortal.bind(this);
		this.onScrollToPortals = this.onScrollToPortals.bind(this);
		this.onVideoOverlayToggle = this.onVideoOverlayToggle.bind(this);
		this.onPageHide = this.onPageHide.bind(this);
		this.onPageShow = this.onPageShow.bind(this);
		this.onInterstitialButtonClickedClick = this.onInterstitialButtonClickedClick.bind(this);
		this.playGenericSound = this.playGenericSound.bind(this);
		this.stopGenericSound = this.stopGenericSound.bind(this);

		Store.on('INTERSTITIAL_BUTTON_CLICKED', this.onInterstitialButtonClickedClick);
		Store.on('INTRO_VIDEO_PLAYING', this.startIntro);
		Store.on('PORTAL_ANIMATION_STARTED', this.onPortalStart);
		Store.on('PORTAL_ANIMATION_ENDED', this.onPortalEnded);
		Store.on('SCROLL_TO_CONTENT', this.onScrollToContent);
		Store.on('CONTENT_TRANSITION_STARTED', this.onTransitionStarted);
		Store.on('GIFT_TRANSITION_STARTED', this.onTransitionStarted);
		Store.on('SKIP_PORTAL', this.onSkipPortal);
		Store.on('SCROLL_TO_PORTALS', this.onScrollToPortals);
		Store.on('TOGGLE_FULLSCREEN', this.onVideoOverlayToggle);
		Store.on('TOGGLE_OVERLAY_OPEN', this.onVideoOverlayToggle);
		Store.on('PAGE_HIDE', this.onPageHide);
		Store.on('PAGE_SHOW', this.onPageShow);
		Store.on('PORTALS_PAGE_LANDING', this.playGenericSound);
		Store.on('PORTALS_PAGE_LEAVE', this.stopGenericSound);
	}

	componentWillUnmount() {
		Store.off('INTERSTITIAL_BUTTON_CLICKED', this.onInterstitialButtonClickedClick);
		Store.off('INTRO_VIDEO_PLAYING', this.startIntro);
		Store.off('PORTAL_ANIMATION_STARTED', this.onPortalStart);
		Store.off('PORTAL_ANIMATION_ENDED', this.onPortalEnded);
		Store.off('SCROLL_TO_CONTENT', this.onScrollToContent);
		Store.off('CONTENT_TRANSITION_STARTED', this.onTransitionStarted);
		Store.off('GIFT_TRANSITION_STARTED', this.onTransitionStarted);
		Store.off('SCROLL_TO_PORTALS', this.onScrollToPortals);
		Store.off('TOGGLE_FULLSCREEN', this.onVideoOverlayToggle);
		Store.off('TOGGLE_OVERLAY_OPEN', this.onVideoOverlayToggle);
		Store.off('PAGE_HIDE', this.onPageHide);
		Store.off('PAGE_SHOW', this.onPageShow);
		Store.off('PORTALS_PAGE_LANDING', this.playGenericSound);
		Store.off('PORTALS_PAGE_LEAVE', this.stopGenericSound);

		window.clearTimeout(this.resetTimeout);
		window.clearTimeout(this.genericTimeout);
	}

	onInterstitialButtonClickedClick() {
		if (!this.intro || !this.intro._src.includes(this.props.pageId)) {
			this.initialise();
		}
	}

	initialise() {
		const { appData, pageId } = this.props;
		const audioRoot = appData?.urls.roots.media + '/audio';
		this.finished = false;

		this.sequence = new Howl({
			volume: 0,
			src: [audioRoot + '/' + pageId + '/full-sequence.wav'],
			sprite: {
				intro: [0, 6000, true],
				portal: [6000, 9177],
				landing: [15000, 6000, true],
			},
			onload: () => {
				Store.emit('SOUND_LOADED');
			}
		});

		this.ambience = new Howl({
			volume: 0,
			src: [audioRoot + '/' + pageId + '/ambience.wav'],
			sprite: {
				ambience: [0, 6000, true]
			}
		});

		this.transition = new Howl({
			volume: 0,
			src: [audioRoot + '/' + pageId + '/transition.wav']
		});
	}

	startIntro() {
		this.activeStage = 'intro';
		this.introId = this.sequence.play('intro');
		if (this.state.muted) {
			this.sequence.volume(0);
		} else {
			this.sequence.fade(0, this.volumeLevel, 500);
		}
	}

	onPortalStart() {
		this.activeStage = 'portal';
		this.sequence.stop(this.introId);
		this.portalId = this.sequence.play('portal');
	}

	onPortalEnded() {
		if (this.finished) {
			return;
		}

		this.activeStage = 'landing';
		this.landingId = this.sequence.play('landing');
	}

	onScrollToContent() {
		this.sequence.fade(this.sequence.volume(), 0, 1000);

		this.resetTimeout = window.setTimeout(() => {
			this.reset();
		}, 1000);
	}

	onSkipPortal() {
		this.sequence.fade(this.sequence.volume(), 0, 1000);
	}

	onTransitionStarted() {
		if (!this.transition.playing()) {
			this.transition.volume(this.state.muted ? 0 : this.volumeLevel);
			this.transition.play();
		}
	}

	onScrollToPortals() {
		this.ambience.fade(this.ambience.volume(), this.state.muted ? 0 : this.volumeLevel, 300);
		this.ambienceTimeout = window.setTimeout(() => {
			this.ambience.stop();
		}, 1000);
	}

	onVideoOverlayToggle(open) {
		if (open) {
			this.ambience.fade(this.ambience.volume(), 0, 300);
		} else {
			this.ambience.fade(0, this.state.muted ? 0 : this.volumeLevel, 300);
		}
	}

	reset() {
		this.finished = true;
		this.sequence.stop();
		Store.get().set({ soundLoaded: false });

		this.ambienceId = this.ambience.play('ambience');
		this.ambience.fade(0, this.state.muted ? 0 : this.volumeLevel, 1000);
	}

	onPageHide() {
		if (this.sequence && this.sequence.playing(this.introId)) {
			this.sequence.pause(this.introId);
		} else if (this.sequence && this.sequence.playing(this.portalId)) {
			this.sequence.pause(this.portalId);
		} else if (this.sequence && this.sequence.playing(this.landingId)) {
			this.sequence.pause(this.landingId);
		} else if (this.generic && this.generic.playing(this.genericId)) {
			this.generic.pause(this.genericId);
		} else if (this.ambience && this.ambience.playing(this.ambienceId)) {
			this.ambience.pause();
		}
	}

	onPageShow() {
		if (this.activeStage === 'portals') {
			this.generic.play(this.genericId);
		} else if (this.finished) {
			this.ambience.play(this.ambienceId);
		} else if (this.activeStage === 'intro') {
			this.sequence.play(this.introId);
		} else if (this.activeStage === 'portal') {
			this.sequence.play(this.portalId);
		} else if (this.activeStage === 'landing') {
			this.sequence.play(this.landingId);
		}
	}

	toggleMute() {
		const muted = !this.state.muted;

		const fade = element => {
			const [soundFrom, soundTo] = muted ? [element.volume(), 0] : [0, this.volumeLevel];
			element.fade(soundFrom, soundTo, 300);
		};
		if (this.ambience?.playing(this.ambienceId)) {
			fade(this.ambience);
		} else if (this.sequence?.playing()) {
			fade(this.sequence);
		} else if (this.generic?.playing(this.genericId)) {
			fade(this.generic);
		}

		this.setState({ muted });

		Store.emit('TOGGLE_MUTE', { muted, id: this.props.pageId });
	}

	playGenericSound() {
		const audioRoot = this.props.appData?.urls.roots.media + '/audio';
		this.activeStage = 'portals';

		this.generic = new Howl({
			volume: 0,
			src: [audioRoot + '/QR-page-ambience.wav'],
			sprite: {
				loop: [0, 6000, true]
			},
			onload: () => {
				this.genericId = this.generic.play('loop');
				this.generic.fade(0, this.state.muted ? 0 : this.volumeLevel, 1000);
			}
		});
	}

	stopGenericSound() {
		if (this.generic) {
			this.generic.fade(this.generic.volume(), 0, 1000);
			this.genericTimeout = window.setTimeout(() => {
				this.generic.stop(this.genericId);
			});
		}
	}

	render({ ariaLabel, wrapperClass }, { muted }) {
		return (
			<button
				ariaLabel={ariaLabel}
				onClick={this.toggleMute}
				class={joinClasses(s.wrapper, wrapperClass, muted && s.muted)}
			/>
		);
	}
}
